import { render, staticRenderFns } from "./BiCompareBoxUserGroup.vue?vue&type=template&id=22772c9b&"
import script from "./BiCompareBoxUserGroup.vue?vue&type=script&lang=js&"
export * from "./BiCompareBoxUserGroup.vue?vue&type=script&lang=js&"
import style0 from "./BiCompareBoxUserGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports